/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelBookingApiResponse } from '../models/CancelBookingApiResponse';
import type { CancelBookingDto } from '../models/CancelBookingDto';
import type { CancelSessionApiResponse } from '../models/CancelSessionApiResponse';
import type { CancelSessionDto } from '../models/CancelSessionDto';
import type { ExtendValidityApiResponse } from '../models/ExtendValidityApiResponse';
import type { ExtendValidityDto } from '../models/ExtendValidityDto';
import type { FetchBookingsApiResponse } from '../models/FetchBookingsApiResponse';
import type { FetchRescheduleHistoryApiResponse } from '../models/FetchRescheduleHistoryApiResponse';
import type { ResolveDisputeApiResponse } from '../models/ResolveDisputeApiResponse';
import type { ResolveDisputeDto } from '../models/ResolveDisputeDto';
import type { RetryDisputeRefundApiResponse } from '../models/RetryDisputeRefundApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminBookingManagementService {
    /**
     * List bookings with filters, search, and pagination
     * @param search Free text search over booking/customer/expert details
     * @param bookingType Filter by booking type
     * @param statuses Filter by one or more booking statuses (includes refunded/disputed as list filters). Can be provided multiple times (?statuses=pending&statuses=refunded). payment_failed bookings are split: not_paid (expired with no payment attempt), payment_declined (a declined attempt was recorded), and payment_failed (neither recorded; mostly before April 2026).
     * @param disputeStatuses Filter by dispute status for bookings that have disputes. If multiple are provided, bookings matching ANY of them will be returned.
     * @param services Filter by one or more service IDs. Can be provided multiple times (?services=svc1&services=svc2).
     * @param dateFrom Filter on bookings.booked_at, on/after this point. Full ISO instant, or a bare YYYY-MM-DD read as the start of that UAE calendar day.
     * @param dateTo Filter on bookings.booked_at, on/before this point. Full ISO instant, or a bare YYYY-MM-DD read as the end of that UAE calendar day.
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns FetchBookingsApiResponse Bookings fetched
     * @throws ApiError
     */
    public static adminBookingsControllerFetchBookingsV1(
        search?: string,
        bookingType: 'all' | 'package' | 'single_session' = 'all',
        statuses?: Array<'pending' | 'active' | 'completed' | 'cancelled' | 'payment_failed' | 'payment_failed_retryable' | 'refunded' | 'disputed' | 'not_paid' | 'payment_declined'>,
        disputeStatuses?: Array<'pending' | 'in_review' | 'resolved' | 'declined'>,
        services?: Array<string>,
        dateFrom?: string,
        dateTo?: string,
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<FetchBookingsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/bookings',
            query: {
                'search': search,
                'bookingType': bookingType,
                'statuses': statuses,
                'disputeStatuses': disputeStatuses,
                'services': services,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get reschedule history for a booking (paginated)
     * @param id Booking UUID or booking number
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns FetchRescheduleHistoryApiResponse Reschedule history fetched
     * @throws ApiError
     */
    public static adminBookingsControllerGetRescheduleHistoryV1(
        id: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<FetchRescheduleHistoryApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/bookings/{id}/reschedule-history',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get full booking detail
     * @param id Booking UUID or booking number
     * @returns any Booking detail fetched
     * @throws ApiError
     */
    public static adminBookingsControllerGetBookingDetailV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/bookings/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Booking not found`,
            },
        });
    }
    /**
     * Cancel a booking and all its upcoming sessions
     * @param id Booking UUID or booking number
     * @param requestBody
     * @returns CancelBookingApiResponse Booking cancelled
     * @throws ApiError
     */
    public static adminBookingsControllerCancelBookingV1(
        id: string,
        requestBody: CancelBookingDto,
    ): CancelablePromise<CancelBookingApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/bookings/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Cannot cancel: booking already cancelled or completed, or active disputes must be resolved first`,
                404: `Booking not found`,
            },
        });
    }
    /**
     * Extend package validity date (package bookings only)
     * @param id Booking UUID or booking number
     * @param requestBody
     * @returns ExtendValidityApiResponse Validity extended
     * @throws ApiError
     */
    public static adminBookingsControllerExtendValidityV1(
        id: string,
        requestBody: ExtendValidityDto,
    ): CancelablePromise<ExtendValidityApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/bookings/{id}/extend-validity',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Not a package booking or already cancelled`,
                404: `Booking not found`,
            },
        });
    }
    /**
     * Cancel an individual session within a booking
     * @param bookingId Booking UUID or booking number
     * @param sessionId Session UUID
     * @param requestBody
     * @returns CancelSessionApiResponse Session cancelled
     * @throws ApiError
     */
    public static adminBookingsControllerCancelSessionV1(
        bookingId: string,
        sessionId: string,
        requestBody: CancelSessionDto,
    ): CancelablePromise<CancelSessionApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/bookings/{bookingId}/sessions/{sessionId}/cancel',
            path: {
                'bookingId': bookingId,
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Session already cancelled or completed`,
                404: `Booking or session not found`,
            },
        });
    }
    /**
     * Resolve a dispute on a booking
     * @param bookingId Booking UUID or booking number
     * @param disputeId Dispute UUID or dispute number
     * @param requestBody
     * @returns ResolveDisputeApiResponse Dispute resolved
     * @throws ApiError
     */
    public static adminBookingsControllerResolveDisputeV1(
        bookingId: string,
        disputeId: string,
        requestBody: ResolveDisputeDto,
    ): CancelablePromise<ResolveDisputeApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/bookings/{bookingId}/disputes/{disputeId}/resolve',
            path: {
                'bookingId': bookingId,
                'disputeId': disputeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Dispute already resolved or declined`,
                404: `Booking or dispute not found`,
            },
        });
    }
    /**
     * Retry Stripe refund initiation for an approved dispute refund
     * @param bookingId Booking UUID or booking number
     * @param disputeId Dispute UUID or dispute number
     * @returns RetryDisputeRefundApiResponse Refund initiation retried
     * @throws ApiError
     */
    public static adminBookingsControllerRetryDisputeRefundV1(
        bookingId: string,
        disputeId: string,
    ): CancelablePromise<RetryDisputeRefundApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/bookings/{bookingId}/disputes/{disputeId}/retry-refund',
            path: {
                'bookingId': bookingId,
                'disputeId': disputeId,
            },
            errors: {
                404: `Booking/dispute or retry-eligible refund not found`,
            },
        });
    }
}
